import JwtDecode from 'jwt-decode';
import * as LocalStorage from './localStorageHelper';

var TOKEN_KEY = 'boozebot_token';

export function store(token) {
  LocalStorage.remove(TOKEN_KEY);
  LocalStorage.put(TOKEN_KEY, token);
  return token;
}

export function retrieve() {
  return LocalStorage.get(TOKEN_KEY);
}

export function decode() {
  var token = retrieve();
  if (token) {
    return JwtDecode(token);
  } else {
    return null;
  }
}

export function destroy() {
  LocalStorage.remove(TOKEN_KEY);
}



// WEBPACK FOOTER //
// ./src/utils/tokenHelpers.js